import { Component, Input, OnInit } from '@angular/core';
import { ArcAngelService } from '../../../core/services/arc-angel.service';
import { DataContextService } from '../../../core/services/data-context.service';
import { DataService } from '../../../core/services/data.service';
import { GlobeService } from '../../../core/services/globe.service';
import { WindowService } from '../../../core/services/window.service';

import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DeviceService } from '../../../core/services/device.service';
interface IncidentUser {
  name: string;
  src: string;
  visible?: boolean;
  status?: string;
}
@Component({
  selector: 'app-user-search-ui',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './user-search-ui.component.html',
  styleUrl: './user-search-ui.component.css'
})

export class UserSearchUiComponent implements OnInit {
  @Input() incidentId!: string;

  data = {
    searchText: '',
    users: [] as IncidentUser[],
    userList: [] as IncidentUser[],
    page: 1,
    limit: 15,
    totalUserCount: 0,
    lastPage: 1
  };
  entity: any;

  enablePlayback = false;

  constructor(
    private dataService: DataService,
    private dataContext: DataContextService,
    private windowService: WindowService,
    private arcAngelService: ArcAngelService,
    public activeModal: NgbActiveModal,
    private globeService: GlobeService,
    private deviceService: DeviceService
  ) { }

  ngOnInit(): void {
    const event = this.dataContext.getMapEntity('arc-angel-' + this.incidentId);
    const incident = event ? event.arcLiveMapEntity : null;
    this.enablePlayback = incident?.status !== 'active';
    this.startSearch();
  }

  startSearch(): void {
    this.data.page = 1;
    this.searchUsers();
  }

  keyDown(e: KeyboardEvent): void {
    if (e.key === 'Enter') {
      this.startSearch();
    }
  }

  searchUsers(): void {
    this.dataService.searchIncidentUsers(this.incidentId, this.data.limit, this.data.page, this.data.searchText)
      .subscribe((results: any) => {
        let users = results?.rows || [];
        users.forEach((user: any) => {
          if (user.name.toLowerCase().includes('suspect')) {
            user.status = 'SUSPECT';
            user.src = 'img/arcangel/user_suspect.svg';
          }
          if (user.status.toLowerCase() === 'danger') {
            user.src = 'img/arcangel/user_in_danger.svg';
          } else if (user.status.toLowerCase() === 'safe') {
            user.src = 'img/arcangel/user_safe.svg';
          } else {
            user.src = 'img/arcangel/user_unknown.svg';
          }
        });
        this.data.users = users;
        this.data.totalUserCount = results?.count ?? 0;
        this.data.lastPage = Math.ceil(this.data.totalUserCount / this.data.limit);
      });
  }

  jumpPage(n: number): void {
    this.data.page += n;
    this.searchUsers();
  }

  toggleUserVisibility(user: any): void {
    user.visible = !user.visible;
    if (user.visible) {
      this.showUser(user);
    } else {
      this.removeUser(user);
    }
  }

  showUser(user: any) {
     const event = this.dataContext.getMapEntity('arc-angel-' + this.incidentId);
    const incident = event ? event.arcLiveMapEntity : null;
     if (!incident) return;
     const entity = this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
     if (!entity) {
       let time;
       if (this.enablePlayback) {
       }
       this.createIncidentDeviceMapEntity(user, incident, time);
       return;
     }
   }
 
   showUserInfo(user: any) {
     const entity = this.getDeviceMapEntityById(user.deviceId);
     if (entity) {
       this.showUsersInfoInWindow(entity);
     }
   }
   getDeviceMapEntityById(deviceId: string): any {
     if (this. entity?.devices?.[deviceId]) {
       return this.entity?.devices?.[deviceId];
     } else if (this.entity?.devices?.[deviceId]) {
       return this.entity?.devices[deviceId];
     }
     return undefined;
   }
   removeUser(user: any) {
     const entity = this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
     if (entity) {
     }
   }
 
   showUsersInfoInWindow(entity: any) {
     if (!this.windowService.isEntityDetailsWindowOpen(entity.getWindowId())) {
       this.globeService.handleClick(this, entity);
     }
   }
 
   createIncidentDeviceMapEntity(user: any, incident: any, time?: string): void {
     let api$: Observable<any>;
     if (this.enablePlayback) {
        api$ = this.deviceService.getIncidentDeviceDataByDeviceId(user, incident);
     } else {
       api$ = this.deviceService.getIncidentDeviceDataByDeviceId(user, incident);
     }
     api$.subscribe({
       next: () => {
       },
       error: (error) => {
         console.error('Error creating/updating device map entity:', error);
       }
     });
   }
}